module.exports = __webpack_public_path__ + "img/CS3-4.5fc6cb44.png";